import { lazy } from 'react';

const list = lazy(() => import('pages/shippingPresets/List'));
const edit = lazy(() => import('pages/shippingPresets/Edit'));
const create = lazy(() => import('pages/shippingPresets/Create'));

export { list, edit, create };
